<template>
  <div>
    <validation-provider
      :name="config.name"
      :rules="fromAlarm ? '' : config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(`commands.form.${config.name}.label`) }}
      </label>
      <v-select
        v-model="model"
        :options="sectors"
        :clearable="true"
        :reduce="(val) => val.value"
        input-id="id_sector"
        :multiple="multiple"
        :disabled="fromAlarm"
        @input="$emit('input', model)"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
    <div class="form-group form-check mt-1" v-if="showFromAlarm">
      <validation-provider vid="sectors_from_alarm">
        <input
          type="checkbox"
          class="form-check-input"
          name="sectors_from_alarm"
          v-model="fromAlarm"
          value="from_alarm"
        />
      </validation-provider>
      <label class="form-check-label">
        {{ $t("commands.form.location.fields.from_alarm") }}
      </label>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: null,
      fromAlarm: false,
      showFromAlarm: false,
    };
  },
  created() {
    this.showFromAlarm = this.context.flowchartConfig.alarm_compatible;
    this.model = this.value || null;
    this.fromAlarm = this.showFromAlarm && this.value === "from_alarm";
  },
  mounted() {
    if (!this.sectors.length) {
      store.dispatch("sector/getAll");
    }
  },
  watch: {
    fromAlarm: {
      handler(value) {
        if (value) {
          this.$emit("input", "from_alarm");
          this.model = null;
        } else {
          this.$emit("input", null);
        }
      },
    },
  },
  computed: {
    sectors() {
      return store.getters["sector/getSelectedItems"];
    },
  },
};
</script>

<style></style>
